import React from "react";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { ArrowBack as ArrowBackIcon } from "@mui/icons-material";

function Header({
  onBack,
  onSyncChanges,
  onTestConnection,
  folders,
  selectedFolder,
  onFolderChange,
  syncEnabled,
  syncing,
}) {
  return (
    <Box
      sx={{
        p: 2,
        display: "flex",
        alignItems: "center",
        backgroundColor: "#202020",
        borderBottom: "1px solid #e0e0e0",
        gap: 2,
      }}
    >
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={onBack}
        sx={{
          mr: 2,
          color: "#fff",
          borderColor: "#fff",
          "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.1)",
          },
        }}
        variant="outlined"
      >
        Back
      </Button>

      <FormControl size="small" sx={{ minWidth: 180 }}>
        <InputLabel id="folder-select-label" sx={{ color: "#fff" }}>
          Change Folder
        </InputLabel>
        <Select
          labelId="folder-select-label"
          value={
            selectedFolder && selectedFolder.folderId
              ? selectedFolder.folderId
              : ""
          }
          label="Change Folder"
          onChange={(event) => {
            onFolderChange(event);
          }}
          sx={{
            color: "#fff",
            ".MuiSvgIcon-root": { color: "#fff" },
            ".MuiOutlinedInput-notchedOutline": { borderColor: "#aaa" },
            "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#fff" },
          }}
        >
          {(folders || [])
            .filter(
              (folder) =>
                folder.status === "draft" || folder.status === "rejected"
            )
            .map((folder) => {
              const key = folder.folderId || folder.id || folder.folderName;
              return (
                <MenuItem key={key} value={folder.folderId}>
                  {folder.folderName}
                </MenuItem>
              );
            })}
        </Select>
      </FormControl>
      <Button
        variant="outlined"
        sx={{
          ml: 2,
          color: "#fff",
          borderColor: "#fff",
          "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.1)",
          },
          "&.Mui-disabled": {
            color: "rgba(255, 255, 255, 0.4)",
            borderColor: "rgba(255, 255, 255, 0.3)",
          },
        }}
        onClick={onSyncChanges}
        disabled={!syncEnabled || syncing}
      >
        Sync Changes
      </Button>
    </Box>
  );
}

export default Header;
